import { ReactElement, useContext, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  SUPPORT_TELEGRAM, FACEBOOK, LINKEDIN, YOUTUBE,
} from 'constants/application';

import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
import { ReactComponent as FacebookIcon } from 'assets/icons/facebook.svg';
import { ReactComponent as LinkedinIcon } from 'assets/icons/linkedin.svg';
import { ReactComponent as YoutubeIcon } from 'assets/icons/youtube.svg';
import { GTM_EVENTS } from 'constants/analytics';
import { fbAnalytics } from 'utils/analytics';
import { JobsApplyContext, UserContext } from 'contexts';
import { JOBS } from 'constants/pathNames';
import styles from './ApplySuccessPage.module.scss';
import useBackInterceptor from '../../hooks/useBackInterceptor';
import { JobsApplyContextType } from '../../contexts/jobsApplyContext';
import { UserContextType } from '../../contexts/userContext';

const ApplySuccessPage = (): ReactElement => {
  const { setJobsData } = useContext<JobsApplyContextType>(JobsApplyContext);
  const { lastSelectedJob } = useContext<UserContextType>(UserContext);

  useBackInterceptor(JOBS);

  useEffect(() => {
    fbAnalytics(GTM_EVENTS.CONGRATULATIONS);
    setJobsData(null);
  }, []);

  return (
    <section className={styles.ApplySuccessHolder} data-qa="applyJobSuccessPageSection">
      <div className={`${styles.ApplySuccessContainer} container container-small`}>
        <div className={styles.ApplySuccess}>
          <div className={styles.Title} data-qa="applyJobSuccessPageTitle_new">
            <CheckIcon />
            <h2>
              <FormattedMessage id="apply_success.congratulations_new" />
            </h2>
            {' '}
            {lastSelectedJob?.title ? (
              <h3>
                <FormattedMessage id="apply_success.congratulations_new3" />
              </h3>
            ) : (
              <h3>
                <FormattedMessage id="apply_success.congratulations_new_we_received_information" />
              </h3>
            )}
            {lastSelectedJob?.title || '' }
          </div>
          <div className={styles.ApplySuccessList} data-qa="applyJobSuccessPageList">
            {lastSelectedJob?.title ? (
              <>
                <p>
                  <FormattedMessage id="apply_success.congratulations_team_member_review_will_review" />
                </p>
                <p>
                  <FormattedMessage id="apply_success.congratulations_please_wait_for_us" />
                </p>
              </>
            ) : (
              <p>
                <FormattedMessage id="apply_success.congratulations_team_member_review_will_contact" />
              </p>
            )}
            <p>
              <FormattedMessage
                id="apply.success_congratulations_support_message"
                values={{
                  supportTelegram: <a href={`https://${SUPPORT_TELEGRAM}`}>{SUPPORT_TELEGRAM}</a>,
                }}
              />
            </p>
          </div>
        </div>
        <div className={styles.ApplySuccessFooter}>
          <a aria-label="facebook" href={FACEBOOK}><FacebookIcon /></a>
          <a aria-label="linkedin" href={LINKEDIN}><LinkedinIcon /></a>
          <a aria-label="youtube" href={YOUTUBE}><YoutubeIcon /></a>
        </div>
      </div>
    </section>
  );
};

export default ApplySuccessPage;
